<template>
    <transition name="fade">
        <section>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 text-center">
                        <h1 class="bold fs-55 pt-3">
                            <i class="fas fa-check-circle success"></i>
                        </h1>
                        <h4 class="bold pb-5">
                            Well done! Your account has been successfully created!
                        </h4>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button class="btn btn-success float-right" @click="gotoDashboard">
                    Proceed to Dashboard<i class="fas fa-arrow-right ml-1"></i>
                </button>
            </div>
            <ModalSurvey :id="'survey-modal'" :borrower_id="borrower_id" :completed="completed" @hide="$emit('next', 5, 1)" />
        </section>
    </transition>
</template>
<script>
    import ModalSurvey from "@vues/ModalSurvey.vue";
    export default {
        props: {
            borrower_id: {
                type: String,
                default: null,
            },
            completed: {
                type: [String, Number],
                default: 0,
            },
        },
        components: {
            ModalSurvey,
        },
        mounted() {
            if (!this.completed) {
                $("#survey-modal").modal("show");
            }
        },
        methods: {
            gotoDashboard() {
                // this.$router.push('/dashboard');
                window.location.href = "/dashboard";
            },
        },
    };
</script>